import * as React from "react"
import { Button, buttonVariants } from "@/components/ui/button"
import { cn } from "@/lib/utils"

export function CustomButton({
                                   className,
                                   variant,
                                   size,
                                   ...props
                               }: React.ComponentProps<typeof Button>) {
    return (
        <Button
            variant={variant}
            size={size}
            className={cn(
                // upstream base styles
                buttonVariants({ variant, size }),

                'hover:cursor-pointer',

                // override outline variant only
                variant === "outline" &&
                "border border-primary text-primary bg-background shadow-xs hover:bg-primary-soft hover:text-primary hover:border-primary",

                // override lg size only
                size === "lg" && "h-12",

                // override icon-lg size only
                size === "icon-lg" && "size-12",

                //ghost variant hover override
                variant === "ghost" && "hover:bg-primary-soft hover:text-primary",

                className
            )}
            {...props}
        />
    )
}

export { buttonVariants }
